import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_CONFIG } from '../config';

const SEO = ({ page }) => {
  const seo = SITE_CONFIG.seo[page] || SITE_CONFIG.seo.home;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={SITE_CONFIG.logoUrl} />
      <link rel="canonical" href={`https://${SITE_CONFIG.domain}`} />
    </Helmet>
  );
};

export default SEO;
